module.exports = __webpack_public_path__ + "static/pc_service_erp-c315330a9c27bf9904637b575b3724f8.jpg";